<div *ngIf="!loading">
<div *ngIf="question.server_question_id!=0" [innerHTML]="question.questionText"></div>
<app-image-question *ngFor="let myImage of question.imageListQuestionBody" [questionId]="myImage.id" [partName]="myImage.part_name"></app-image-question>
<form [formGroup]="doQuestionForm"  *ngIf="question.server_question_id!=0">
    <span *ngIf="isRadioGroup">

    (<i>Select the Correct Answer from options below</i>)
    <table class="table">
       <tr *ngFor="let choice of question.choices; index as myCount">
        <td>
           <div class="answer-option-radio-div">
             <input
             type="radio"
             [id]="myCount"
             formControlName="answerChoice"
             [value]="extractChoiceValue(choice)"
             style="height:35px; width:35px; vertical-align: middle;"/>
             <span [appMath]="' '+choice.display"></span>
        </div>
        </td>
    </tr>
   </table>
    </span>
        <div class="row"  *ngIf="isInput">
            <div class="col-sm-4" ></div>
            <div class="col-sm-4" >
                <input   formControlName="answerInput" class="form-control"/>
            </div>
        </div>
    </form>
    <table class="table">
      <tr><td>Template Id</td><td>
       {{question.server_task_template_id}}
    </td></tr>

        <tr><td>Task Template</td><td>
            <a [routerLink]="['/task/template/show',question.server_task_template_id]">{{question.templateName}}</a>
        </td></tr>
        <tr><td>Template Detail</td><td>{{question.template_detail}}</td></tr>
    </table>
    <div class="tex-center">
        <a [routerLink]="['/admin/envelop/quiz',server_quiz_envelop_id]" class="btn btn-primary w-100"> Back To Quiz Envelop</a>
    </div>
</div>
